/*
* Pipeline Theme
*
* Use this file to add custom Javascript to Pipeline.  Keeping your custom
* Javascript in this fill will make it easier to update Pipeline. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*
*/


(function() {

  // Below are example event listeners.  They listen for theme events that Pipeline
  // fires in order to make it easier for you to add customizations.

  // Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.


  document.addEventListener('theme:variant:change', function(event) {
    // You might use something like this to write a pre-order feature or a
    // custom swatch feature.
    var variant = event.detail.variant;
    var container = event.target;
    if (variant) {
      console.log('Container ———————— ↓');
      console.log(container);
      console.log('Variant —————————— ↓');
      console.log(variant);
      // ... update some element on the page
    }
  });

  document.addEventListener('theme:cart:change', function(event) {
    var cart = event.detail.cart;
    if (cart) {
      console.log('Cart ———————————— ↓');
      console.log(cart);
      // ... update an app or a custom shipping caluclator
    }
  });
  // Fired when page loads to update header values
  document.addEventListener('theme:cart:init', (e) => {
    console.log('theme:cart:init');
    console.log(e);
  });

  // Debounced scroll listeners.  Up and down only fire on direction changes
  // These events are useful for creating sticky elements and popups.
  document.addEventListener('theme:scroll', e => { console.log(e); });
  document.addEventListener('theme:scroll:up', e => { console.log(e); });
  document.addEventListener('theme:scroll:down', e => { console.log(e); });

  // Debounced resize listener to bundle changes that trigger document reflow
  document.addEventListener('theme:resize', e => { console.log(e); });

  // Locks and unlocks page scroll for modals and drawers
  // These are commented out because firing them will lock the page scroll
  // the lock event must set `detail` to the modal or drawer body so the 
  // scroll locking code knows what element should maintain scoll. 
  // document.dispatchEvent(new CustomEvent('theme:scroll:lock', {bubbles: true, detail: scrollableInnerElement}));
  // document.dispatchEvent(new CustomEvent('theme:scroll:unlock', {bubbles: true}));

  // swatches with colour name
  window.addEventListener("load", function () {
  const swatches = document.querySelectorAll(".swatch__button.related-product");
  const labelTarget = document.querySelector(".selected-color-name");

  console.log("Window loaded — found swatches:", swatches.length); // Debug

  if (!labelTarget || !swatches.length) return;

  const originalLabel = labelTarget.textContent.trim();
  labelTarget.setAttribute("data-original-color", originalLabel);

  swatches.forEach((swatch) => {
    const colorLabel = swatch.getAttribute("data-color-label")?.trim();

    swatch.addEventListener("mouseenter", () => {
      console.log("Hovered on:", colorLabel); 
      if (colorLabel) {
        labelTarget.textContent = colorLabel;
      }
    });

    swatch.addEventListener("mouseleave", () => {
      const original = labelTarget.getAttribute("data-original-color");
      if (original) {
        labelTarget.textContent = original;
      }
    });
  });
});

//arrows on product image @product page
document.addEventListener("DOMContentLoaded", function () {
  // Only target thumbnails in product media galleries, not cart drawers
  const productMediaWrappers = document.querySelectorAll('.product__media__wrapper, [data-product-media-wrapper]');
  
  productMediaWrappers.forEach(wrapper => {
    const thumbnails = Array.from(wrapper.querySelectorAll('[data-slideshow-thumbnail]'));
    console.log("Thumbnails found in product media:", thumbnails);

    if (thumbnails.length === 0) return;

    let currentIndex = 0;

    function goToImage(index) {
      console.log("Attempting to go to image index:", index);
      if (index >= 0 && index < thumbnails.length) {
        thumbnails[index].click();
        currentIndex = index;
        updateArrowVisibility();
      }
    }

    thumbnails.forEach((thumb, index) => {
      thumb.addEventListener('click', () => {
        currentIndex = index;
        updateArrowVisibility();
      });
    });

    const mainImageWrapper = wrapper.querySelector('.flickity-viewport');
    console.log("Main image wrapper:", mainImageWrapper);

    if (!mainImageWrapper) {
      console.warn("Missing main wrapper in product media");
      return;
    }

    // Check if arrows already exist to avoid duplicates
    if (mainImageWrapper.querySelector('.custom-arrow')) {
      console.log("Custom arrows already exist, skipping");
      return;
    }

    const leftArrow = document.createElement('button');
    leftArrow.innerHTML = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M15 18L9 12L15 6" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
</svg>`;
    leftArrow.className = 'custom-arrow left-arrow';
    leftArrow.onclick = () => goToImage(currentIndex - 1);

    const rightArrow = document.createElement('button');
    rightArrow.innerHTML = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M9 18L15 12L9 6" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
</svg>`;
    rightArrow.className = 'custom-arrow right-arrow';
    rightArrow.onclick = () => goToImage(currentIndex + 1);

    mainImageWrapper.appendChild(leftArrow);
    mainImageWrapper.appendChild(rightArrow);

    function updateArrowVisibility() {
      if (currentIndex === 0) {
        leftArrow.style.display = 'none';
        rightArrow.style.display = 'block';
      }
      else if (currentIndex === thumbnails.length - 1) {
        leftArrow.style.display = 'block';
        rightArrow.style.display = 'none';
      }
      else {
        leftArrow.style.display = 'block';
        rightArrow.style.display = 'block'; 
      }
    }
    updateArrowVisibility();
  });
});

// Add this CSS to ensure cart drawer doesn't get arrows
const style = document.createElement('style');
style.innerHTML = `
  /* Only show arrows in product media, not cart drawer */
  .product__media__wrapper .custom-arrow,
  [data-product-media-wrapper] .custom-arrow {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    border: none;
    font-size: 24px;
    cursor: pointer;
    z-index: 10;
    padding: 0.5em 0.5em;
    border-radius: 100%;
    transition: background 0.3s ease, transform 0.3s ease, opacity 0.3s ease;
  }

  .product__media__wrapper .custom-arrow:hover,
  [data-product-media-wrapper] .custom-arrow:hover {
    background: #FFF;
    border-radius: 100%;
  }
  
  .product__media__wrapper .custom-arrow svg,
  [data-product-media-wrapper] .custom-arrow svg {
    width: 24px;
    height: 24px;
  }

  .product__media__wrapper .left-arrow,
  [data-product-media-wrapper] .left-arrow { 
    left: 16px; 
  }
  
  .product__media__wrapper .right-arrow,
  [data-product-media-wrapper] .right-arrow { 
    right: 16px; 
  }
  
  /* Hide arrows in cart drawer */
  .cart-drawer-slider .custom-arrow,
  [data-section-id*="cart-drawer"] .custom-arrow {
    display: none !important;
  }
`;
document.head.appendChild(style);

// Load more pagination with product counter (simplified version)
class LoadMorePagination {
  constructor() {
    if ((this.button = document.querySelector('.load-more-btn')) && 
        (this.container = document.querySelector('.js-grid'))) {
      // Get total products from data attribute
      this.totalProducts = parseInt(this.button.dataset.totalProducts) || 0;
      
      // Create product counter
      this.createProductCounter();
      
      // Initialize product count
      this.updateProductCount();
      
      this.button.addEventListener('click', () => this.handleClick());
      this.paginationContainer = document.querySelector('.text-center');
    }
  }
  
  createProductCounter() {
    if (document.querySelector('.product-counter')) return;
    
    this.counterElement = document.createElement('div');
    this.counterElement.className = 'product-counter';
    
    this.button.parentNode.insertBefore(this.counterElement, this.button);
  }
  
updateProductCount() {
  if (!this.counterElement) return;
  
  // Get current product count
  const currentProducts = this.container.querySelectorAll('.product-grid-item, [data-product-item], .grid__item').length;
  
  // Use the total from data attribute or current count as fallback
  const total = this.totalProducts || currentProducts;
  
  // Check if button is hidden to determine if we've reached the end
  const isEnd = this.button.style.display === 'none' || !this.button.dataset.nextUrl;
  
  // Update counter text
  if (!isEnd) {
    this.counterElement.textContent = `${currentProducts} of ${total} products`;
    this.counterElement.classList.remove('end-message');
  } else {
    this.counterElement.textContent = `You've reached the end - ${total} products`;
    this.counterElement.classList.add('end-message');
  }
}
  
  async handleClick() {
    if (this.loading) return;
    this.loading = true;
    this.button.disabled = true;
    this.button.classList.add('loading'); 
    try {
      const res = await fetch(this.button.dataset.nextUrl);
      const html = await res.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const grid = doc.querySelector('.js-grid');
      
      this.container.insertAdjacentHTML('beforeend', grid.innerHTML);
      
      const newPagination = doc.querySelector('.text-center')?.innerHTML;
      if (newPagination && this.paginationContainer) {
        this.paginationContainer.innerHTML = newPagination;
      }
      
      const newNextUrl = doc.querySelector('.load-more-btn')?.dataset.nextUrl;
      if (newNextUrl) {
        this.button.dataset.nextUrl = newNextUrl;
      } else {
        this.button.disabled = true;
        this.button.style.display = 'none';
        this.counterElement.classList.add('end-message');
      }
      
      // Update product count after loading new products
      this.updateProductCount();
    } catch (err) {
      console.error('Error:', err);
      const btnText = this.button.querySelector('.btn-text');
      btnText.textContent = 'Error loading products. Try again.';
      setTimeout(() => btnText.textContent = 'Load More Products', 2000);
    } finally {
      this.loading = false;
      this.button.disabled = !this.button.dataset.nextUrl;
      this.button.classList.remove('loading'); 
    }
  }
}

document.addEventListener('DOMContentLoaded', () => new LoadMorePagination());

// add products from empty cart
document.addEventListener('DOMContentLoaded', function () {
  document.addEventListener('theme:cart:change', function (e) {
    try {
      const cart = e?.detail?.cart;
      if (!cart) return;

      const emptyContainer = document.querySelector('[data-cart-empty]');
      if (!emptyContainer) return;

      // If empty state is visible (it won't have the hidden class) and cart now has items
      const isEmptyVisible = !emptyContainer.classList.contains('cart--hidden');
      if (isEmptyVisible && cart.item_count > 0) {
        // Give theme some microtime to set internal values and then trigger reload
        setTimeout(() => {
          document.dispatchEvent(new CustomEvent('theme:cart:reload', { detail: { cart } }));
        }, 10);
      }
    } catch (err) {
      console.error('theme:cart:change listener error', err);
    }
  });
});
 
//make accordion menu work on tablet
document.addEventListener('DOMContentLoaded', function() {
  let tabletAccordionInitialized = false;
  
  function initTabletAccordions() {
    if (tabletAccordionInitialized) return;
    
    const isTablet = window.innerWidth >= 769; 
    
    if (!isTablet) {
      tabletAccordionInitialized = false;
      return;
    }
    
    // Find all mobile accordion triggers
    const tabletTriggers = document.querySelectorAll('.mobile-accordion__head[data-accordion-trigger]');
    
    tabletTriggers.forEach(trigger => {
      const targetId = trigger.getAttribute('data-accordion-trigger');
      const content = document.getElementById(targetId);
      const icon = trigger.querySelector('.mobile-accordion__icon');
      
      // Force close all accordions on tablet
      trigger.setAttribute('aria-expanded', 'false');
      if (content) {
        content.setAttribute('aria-hidden', 'true');
        content.style.maxHeight = '0';
        content.style.opacity = '0';
        content.style.overflow = 'hidden';
        // Remove padding/margin only when closed
        content.style.paddingTop = '0';
        content.style.paddingBottom = '0';
        content.style.marginTop = '0';
        content.style.marginBottom = '0';
      }
      
      if (icon) {
        icon.style.transform = 'rotate(0deg)';
      }
      
      // Replace the trigger to remove existing event listeners
      const newTrigger = trigger.cloneNode(true);
      trigger.parentNode.replaceChild(newTrigger, trigger);
      
      const currentTrigger = newTrigger;
      const currentContent = document.getElementById(targetId);
      const currentIcon = currentTrigger.querySelector('.mobile-accordion__icon');
      
      // Add our custom click handler for tablet
      currentTrigger.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        
        const isExpanded = currentTrigger.getAttribute('aria-expanded') === 'true';
        
        if (isExpanded) {
          // Close accordion - remove spacing
          currentTrigger.setAttribute('aria-expanded', 'false');
          if (currentContent) {
            currentContent.setAttribute('aria-hidden', 'true');
            currentContent.style.maxHeight = '0';
            currentContent.style.opacity = '0';
            // Remove spacing when closing
            currentContent.style.paddingTop = '0';
            currentContent.style.paddingBottom = '0';
            currentContent.style.marginTop = '0';
            currentContent.style.marginBottom = '0';
          }
          if (currentIcon) currentIcon.style.transform = 'rotate(0deg)';
        } else {
          // Open accordion - restore spacing
          currentTrigger.setAttribute('aria-expanded', 'true');
          if (currentContent) {
            currentContent.setAttribute('aria-hidden', 'false');
            currentContent.style.maxHeight = currentContent.scrollHeight + 'px';
            currentContent.style.opacity = '1';
            // Restore original spacing when opening
            currentContent.style.paddingTop = '';
            currentContent.style.paddingBottom = '';
            currentContent.style.marginTop = '';
            currentContent.style.marginBottom = '';
          }
          if (currentIcon) currentIcon.style.transform = 'rotate(180deg)';
        }
      });
    });
    
    tabletAccordionInitialized = true;
  }
  
  function checkAndInitTabletAccordions() {
    const isTablet = window.innerWidth >= 769; // CHANGED THIS LINE
    if (isTablet) {
      setTimeout(initTabletAccordions, 100);
    } else {
      tabletAccordionInitialized = false;
    }
  }
  
  checkAndInitTabletAccordions();
  window.addEventListener('resize', checkAndInitTabletAccordions);
  
  const menuToggle = document.querySelector('[data-drawer-toggle], .mobile-menu-toggle');
  if (menuToggle) {
    menuToggle.addEventListener('click', function() {
      setTimeout(checkAndInitTabletAccordions, 300);
    });
  }
});

// Updated CSS - for screens >= 768px
const tabletStyles = `
@media (min-width: 769px) {
  .mobile-accordion__content[data-accordion-body] {
    max-height: 0;
    opacity: 0;
    overflow: hidden;
    transition: max-height 0.3s ease, opacity 0.2s ease !important;
    display: block !important;
  }
  
  /* Remove spacing only when accordion is closed */
  .mobile-accordion__content[data-accordion-body][aria-hidden="true"] {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  
  /* Keep original spacing when accordion is open */
  .mobile-accordion__content[data-accordion-body][aria-hidden="false"] {
    padding-top: initial !important;
    padding-bottom: initial !important;
    margin-top: initial !important;
    margin-bottom: 20px !important;
  }
  
  .mobile-accordion__icon {
    transition: transform 0.3s ease !important;
  }
}
`;

const styleSheet = document.createElement('style');
styleSheet.textContent = tabletStyles;
document.head.appendChild(styleSheet);

// Simple mobile search handler for mobile and tablets
document.addEventListener('DOMContentLoaded', function() {
  // Run on mobile and tablets (up to 1200px)
  const isMobileOrTablet = window.innerWidth <= 1200;
  if (!isMobileOrTablet) return;
  
  const mobileSearchTriggers = document.querySelectorAll('.mobile-search-trigger');
  
  mobileSearchTriggers.forEach(trigger => {
    trigger.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      
      const searchPopdown = document.getElementById('search-popdown');
      const searchUnderlay = document.querySelector('[data-search-underlay]');
      
      if (searchPopdown && searchUnderlay) {
        // Toggle search using theme's classes
        searchPopdown.classList.toggle('is-visible');
        searchUnderlay.classList.toggle('underlay--visible');
        
        // Add mobile class for styling
        searchPopdown.classList.toggle('mobile-search-active');
        
        // Handle body scroll
        if (searchPopdown.classList.contains('is-visible')) {
          document.body.style.overflow = 'hidden';
          
          // Focus search input
          setTimeout(() => {
            const searchInput = searchPopdown.querySelector('input[type="search"]');
            if (searchInput) searchInput.focus();
          }, 100);
        } else {
          document.body.style.overflow = '';
        }
      }
    });
  });
  
  // Close handling
  document.addEventListener('click', function(e) {
    if (e.target.closest('[data-close-popdown]') || 
        e.target.closest('[data-search-underlay]')) {
      const searchPopdown = document.getElementById('search-popdown');
      const searchUnderlay = document.querySelector('[data-search-underlay]');
      
      if (searchPopdown && searchUnderlay) {
        searchPopdown.classList.remove('is-visible', 'mobile-search-active');
        searchUnderlay.classList.remove('underlay--visible');
        document.body.style.overflow = '';
      }
    }
  });
  
  // Handle ESC key
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') {
      const searchPopdown = document.getElementById('search-popdown');
      const searchUnderlay = document.querySelector('[data-search-underlay]');
      
      if (searchPopdown && searchPopdown.classList.contains('is-visible')) {
        searchPopdown.classList.remove('is-visible', 'mobile-search-active');
        searchUnderlay.classList.remove('underlay--visible');
        document.body.style.overflow = '';
      }
    }
  });
  
  // Handle window resize
  window.addEventListener('resize', function() {
    // If user resizes to desktop while search is open, close it
    if (window.innerWidth > 1200) {
      const searchPopdown = document.getElementById('search-popdown');
      const searchUnderlay = document.querySelector('[data-search-underlay]');
      
      if (searchPopdown && searchPopdown.classList.contains('is-visible')) {
        searchPopdown.classList.remove('is-visible', 'mobile-search-active');
        if (searchUnderlay) searchUnderlay.classList.remove('underlay--visible');
        document.body.style.overflow = '';
      }
    }
  });
});

//cart progress bar
document.addEventListener('DOMContentLoaded', function() {
  function updateProgressBar(cart) {
    var progressFills = document.querySelectorAll('.cart__progress-bar-fill');
    if (!progressFills.length) return;
    
    progressFills.forEach(function(progressFill) {
      var shippingProgress = progressFill.closest('.cart__shipping-progress');
      if (!shippingProgress) return;
      
      var limit = parseFloat(shippingProgress.dataset.limit) || 75;
      var subtotal = cart.total_price / 100;
      
      var percent = Math.min((subtotal / limit) * 100, 100);
      percent = Math.max(percent, 0);
      
      progressFill.style.width = percent + '%';
      
      if (percent >= 100) {
        progressFill.style.backgroundColor = '#475F18';
        progressFill.classList.add('is-full');
      } else {
        progressFill.style.backgroundColor = '#C78627';
        progressFill.classList.remove('is-full');
      }
      
      var messageDefault = shippingProgress.querySelector('.cart__message-default');
      var messageSuccess = shippingProgress.querySelector('.cart__message-success');
      
      if (percent >= 100 && messageSuccess) {
        shippingProgress.classList.add('is-success');
        if (messageDefault) messageDefault.style.display = 'none';
        messageSuccess.style.display = 'block';
      } else {
        shippingProgress.classList.remove('is-success');
        if (messageDefault) messageDefault.style.display = 'block';
        if (messageSuccess) messageSuccess.style.display = 'none';
      }
    });
  }
  
  document.addEventListener('theme:cart:change', function(e) {
    if (e.detail && e.detail.cart) {
      updateProgressBar(e.detail.cart);
    }
  });
  
  // Use cart data injected from theme.liquid
  if (typeof window.shopifyCartData !== 'undefined') {
    updateProgressBar(window.shopifyCartData);
  }
});

// Cart visibility overrides
document.addEventListener('DOMContentLoaded', function() {
  setTimeout(function() {
    if (typeof CartItems !== 'undefined') {
      var originalShowEmpty = CartItems.prototype.showEmpty;
      var originalShowForm = CartItems.prototype.showForm;
      
      CartItems.prototype.showEmpty = function() {
        if (this.bar) this.bar.classList.add('cart--hidden');
        if (this.ship) this.ship.classList.add('cart--hidden');
        this.emptystate.classList.remove('cart--hidden');
        this.loader.classList.remove('cart--loading');
        this.form.classList.add('cart--hidden');
        this.bottom.classList.add('cart--hidden');
      };
      
      CartItems.prototype.showForm = function() {
        originalShowForm.call(this);
        if (this.progress) {
          this.progress.classList.remove('cart--hidden');
        }
      };
    }
  }, 1000);
});

// Mutation observer
var cartHiddenObserver = new MutationObserver(function(mutations) {
  mutations.forEach(function(mutation) {
    if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
      var target = mutation.target;
      if ((target.classList.contains('cart__shipping-container') || 
           target.classList.contains('cart__shipping-progress') ||
           target.classList.contains('cart__progress-bar-outline')) &&
          target.classList.contains('cart--hidden')) {
        target.classList.remove('cart--hidden');
      }
    }
  });
});

// Visibility check - only when cart is open
var visibilityCheckInterval = null;

function startVisibilityCheck() {
  if (visibilityCheckInterval) return;
  
  visibilityCheckInterval = setInterval(function() {
    var cartDrawer = document.querySelector('[data-cart-drawer]');
    var isCartOpen = cartDrawer && 
                     (cartDrawer.classList.contains('is-visible') || 
                      cartDrawer.classList.contains('is-active') ||
                      cartDrawer.style.display !== 'none');
    
    if (!isCartOpen) {
      stopVisibilityCheck();
      return;
    }
    
    var progressElements = document.querySelectorAll(
      '.cart__shipping-container, .cart__shipping-progress, .cart__progress-bar-outline, [data-cart-shipping-container]'
    );
    
    progressElements.forEach(function(el) {
      if (el.classList.contains('cart--hidden')) {
        el.classList.remove('cart--hidden');
      }
      el.style.display = 'block';
      el.style.visibility = 'visible';
      el.style.opacity = '1';
    });
  }, 1000);
}

function stopVisibilityCheck() {
  if (visibilityCheckInterval) {
    clearInterval(visibilityCheckInterval);
    visibilityCheckInterval = null;
  }
}

document.addEventListener('theme:cart:open', startVisibilityCheck);
document.addEventListener('cart:open', startVisibilityCheck);
document.addEventListener('theme:cart:close', stopVisibilityCheck);
document.addEventListener('cart:close', stopVisibilityCheck);

document.addEventListener('DOMContentLoaded', function() {
  var progressElements = document.querySelectorAll(
    '.cart__shipping-container, .cart__shipping-progress, .cart__progress-bar-outline, [data-cart-shipping-container]'
  );
  
  progressElements.forEach(function(el) {
    cartHiddenObserver.observe(el, { 
      attributes: true, 
      attributeFilter: ['class'] 
    });
    el.classList.remove('cart--hidden');
  });
  
  var cartDrawer = document.querySelector('[data-cart-drawer]');
  if (cartDrawer && (cartDrawer.classList.contains('is-visible') || 
                     cartDrawer.classList.contains('is-active'))) {
    startVisibilityCheck();
  }
});

(function() {
  'use strict';
  
  // Wait for DOM to be ready
  function ready(fn) {
    if (document.readyState !== 'loading') {
      fn();
    } else {
      document.addEventListener('DOMContentLoaded', fn);
    }
  }
  
  // Cache all localStorage reads at the start
  const newsletterState = {
    submitted: localStorage.getItem('newsletterSubmitted') === 'true',
    btnClosed: localStorage.getItem('floatingBtnClosed') === 'true',
    popupShown: localStorage.getItem('homepagePopupShown') === 'true'
  };
  
  // Early exit if already submitted
  const urlParams = new URLSearchParams(window.location.search);
  const customerPosted = urlParams.get('customer_posted') === 'true';
  
  if (customerPosted) {
    localStorage.setItem('newsletterSubmitted', 'true');
    newsletterState.submitted = true;
    const cleanUrl = window.location.protocol + "//" + window.location.host + window.location.pathname + window.location.hash;
    window.history.replaceState({}, document.title, cleanUrl);
  }
  
  if (newsletterState.submitted) {
    return; // Exit immediately - no need to run any code
  }
  
  // Cache DOM elements
  let btn, popup, popupInner, backdrop, closeBtn, isHomepage;
  
  function init() {
    btn = document.getElementById('newsletter-floating-btn');
    popup = document.querySelector('[data-newsletter]');
    popupInner = popup?.querySelector('[data-popup-inner]');
    backdrop = document.getElementById('popup-backdrop');
    closeBtn = document.getElementById('floating-close-btn');
    
    if (!popup || !backdrop) return;
    
    isHomepage = window.location.pathname === '/' || 
                 window.location.pathname === '/index' ||
                 window.location.pathname === '/index.liquid' ||
                 document.body.classList.contains('template-index');
    
    // Setup close button
    if (closeBtn && btn) {
      closeBtn.addEventListener('click', handleFloatingClose, { once: true });
    }
    
    // Show floating button on all pages (unless closed)
    if (btn && !newsletterState.btnClosed) {
      setTimeout(() => btn.style.display = 'block', 5000);
      btn.addEventListener('click', () => {
        cleanupScrollHandler(); // Remove scroll handler when button is clicked
        showPopupWithBackdrop('floating-button');
      });
    }
    
    // Setup scroll trigger for homepage only
    if (isHomepage && !newsletterState.btnClosed) {
      setTimeout(setupScrollTrigger, 3000);
    }
    
    // Setup popup close handlers
    setupPopupCloseHandlers();
    setupFormSubmissionHandler();
  }
  
  function handleFloatingClose(e) {
    e.preventDefault();
    e.stopPropagation();
    
    btn.style.display = 'none';
    localStorage.setItem('floatingBtnClosed', 'true');
    newsletterState.btnClosed = true;
    
    cleanupScrollHandler();
  }
  
 function showPopupWithBackdrop(source) {
  if (newsletterState.submitted || newsletterState.btnClosed) return;
  
  // Only check popupShown for homepage scroll trigger specifically
  if (source === 'homepage-scroll' && newsletterState.popupShown) return;
  
  // Ensure popup starts invisible
  popup.style.opacity = '0';
  popup.style.display = 'block';
  popup.style.visibility = 'visible';
  popup.style.zIndex = '9999';
  
  if (popupInner) {
    popupInner.style.opacity = '0';
    popupInner.style.display = 'block';
    popupInner.style.visibility = 'visible';
  }
  
  // Show backdrop and trigger reflow
  backdrop.style.display = 'block';
  
  // Force browser reflow to enable transition
  backdrop.offsetHeight;
  
  // Fade in both backdrop and popup simultaneously
  requestAnimationFrame(() => {
    backdrop.style.opacity = '1';
    popup.style.opacity = '1';
    if (popupInner) popupInner.style.opacity = '1';
  });
  
  popup.classList.add('popup--open', 'is-visible');
  document.body.classList.add('popup--open', 'modal-open');
  
  const emailField = popup.querySelector('input[type="email"]');
  if (emailField) {
    setTimeout(() => emailField.focus(), 100);
  }
  
  if (btn) btn.style.display = 'none';
  
  if (source === 'homepage-scroll' && isHomepage) {
    localStorage.setItem('homepagePopupShown', 'true');
    newsletterState.popupShown = true;
  }
  
  cleanupScrollHandler();
}

function hidePopupWithBackdrop() {
  // Fade out both backdrop and popup together
  backdrop.style.opacity = '0';
  popup.style.opacity = '0';
  
  if (popupInner) {
    popupInner.style.opacity = '0';
    popupInner.style.transition = 'opacity 0.3s ease';
  }
  
  setTimeout(() => {
    backdrop.style.display = 'none';
    popup.style.display = 'none';
    popup.classList.remove('popup--open', 'is-visible');
    document.body.classList.remove('popup--open', 'modal-open');
    
    if (popupInner) {
      popupInner.style.opacity = '1';
      popupInner.style.transition = '';
    }
    
    if (btn && !newsletterState.submitted && !newsletterState.btnClosed) {
      setTimeout(() => btn.style.display = 'block', 3000);
    }
  }, 300);
}
  
  // Debounced scroll handler
  function setupScrollTrigger() {
    let scrollTimeout;
    let scrollTriggered = false;
    
    window.newsletterScrollHandler = function() {
      // Only check if already triggered in THIS session, not from localStorage
      if (scrollTriggered || newsletterState.submitted || newsletterState.btnClosed) {
        cleanupScrollHandler();
        return;
      }
      
      if (scrollTimeout) return;
      
      scrollTimeout = setTimeout(() => {
        const scrollPosition = window.scrollY + window.innerHeight;
        const documentHeight = document.body.scrollHeight;
        
        if (scrollPosition >= documentHeight - 100) {
          scrollTriggered = true;
          showPopupWithBackdrop('homepage-scroll');
          cleanupScrollHandler();
        }
        
        scrollTimeout = null;
      }, 200);
    };
    
    window.addEventListener('scroll', window.newsletterScrollHandler, { passive: true });
    window.newsletterScrollHandler();
  }
  
  function cleanupScrollHandler() {
    if (window.newsletterScrollHandler) {
      window.removeEventListener('scroll', window.newsletterScrollHandler);
      window.newsletterScrollHandler = null;
    }
  }
  
  function setupPopupCloseHandlers() {
    const popupCloseBtn = popup.querySelector('[data-close-modal]');
    if (popupCloseBtn) {
      popupCloseBtn.addEventListener('click', (e) => {
        e.preventDefault();
        hidePopupWithBackdrop();
      });
    }
    
    backdrop.addEventListener('click', (e) => {
      if (e.target === backdrop) hidePopupWithBackdrop();
    });
    
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && popup.style.display === 'block') {
        hidePopupWithBackdrop();
      }
    }, { passive: true });
    
    document.addEventListener('click', (e) => {
      if (popup.style.display === 'block' && 
          !e.target.closest('[data-popup-inner]') && 
          !e.target.closest('#newsletter-floating-btn') &&
          e.target !== backdrop) {
        hidePopupWithBackdrop();
      }
    });
  }
  
  function setupFormSubmissionHandler() {
    const form = popup.querySelector('form');
    if (form) {
      form.addEventListener('submit', () => {
        localStorage.setItem('newsletterSubmitted', 'true');
        newsletterState.submitted = true;
        
        cleanupScrollHandler();
        
        if (btn) btn.style.display = 'none';
      });
    }
  }
  
  // Initialize when DOM is ready using the ready function
  ready(init);
})();


// Custom FAQ Accordion - Optimized Version
(function() {
  'use strict';
  
  // Check if we should initialize
  function shouldInitialize() {
    return document.querySelectorAll('[data-faq-toggle]').length > 0;
  }
  
  // Clean up any inline styles before animating
  function resetAccordionStyles(target) {
    target.style.removeProperty('height');
    target.style.removeProperty('overflow');
    target.style.removeProperty('transition-duration');
    target.style.removeProperty('transition-property');
    target.style.removeProperty('transition-timing-function');
    target.style.removeProperty('padding-top');
    target.style.removeProperty('padding-bottom');
    target.style.removeProperty('margin-top');
    target.style.removeProperty('margin-bottom');
    target.style.removeProperty('max-height');
    target.style.removeProperty('opacity');
  }
  
  // SlideDown function - for opening
  function customSlideDown(target, duration = 400) {
    // Reset any existing inline styles
    resetAccordionStyles(target);
    
    // Get the natural display
    let display = window.getComputedStyle(target).display;
    
    // If already visible, just return
    if (display !== 'none') {
      return;
    }
    
    // Make sure element is displayed so we can measure height
    target.style.display = 'block';
    
    // Get the full height
    let height = target.offsetHeight;
    
    // Reset again to ensure clean state
    resetAccordionStyles(target);
    
    // Set initial state for animation
    target.style.overflow = 'hidden';
    target.style.height = '0';
    target.style.paddingTop = '0';
    target.style.paddingBottom = '0';
    target.style.marginTop = '0';
    target.style.marginBottom = '0';
    target.style.opacity = '0';
    target.style.display = 'block';
    
    // Force reflow using requestAnimationFrame for better performance
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        // Apply transitions
        target.style.boxSizing = 'border-box';
        target.style.transitionTimingFunction = 'cubic-bezier(0.215, 0.61, 0.355, 1)';
        target.style.transitionProperty = 'height, margin, padding, opacity';
        target.style.transitionDuration = duration + 'ms';
        
        // Animate to full height
        target.style.height = height + 'px';
        target.style.opacity = '1';
        target.style.removeProperty('padding-top');
        target.style.removeProperty('padding-bottom');
        target.style.removeProperty('margin-top');
        target.style.removeProperty('margin-bottom');
      });
    });
    
    // Clean up after animation
    window.setTimeout(() => {
      resetAccordionStyles(target);
      target.style.display = 'block';
      target.style.opacity = '1';
    }, duration + 50);
  }
  
  // SlideUp function - for closing
  function customSlideUp(target, duration = 400) {
    // Check if already hidden
    if (target.style.display === 'none' || target.offsetHeight === 0) {
      return;
    }
    
    // Reset any existing inline styles
    resetAccordionStyles(target);
    
    // Make sure element is displayed
    target.style.display = 'block';
    
    // Force reflow using requestAnimationFrame
    requestAnimationFrame(() => {
      // Get current height
      let height = target.offsetHeight;
      
      // Reset again
      resetAccordionStyles(target);
      
      // Apply transitions
      target.style.transitionProperty = 'height, margin, padding, opacity';
      target.style.transitionTimingFunction = 'cubic-bezier(0.215, 0.61, 0.355, 1)';
      target.style.transitionDuration = duration + 'ms';
      target.style.boxSizing = 'border-box';
      target.style.overflow = 'hidden';
      target.style.height = height + 'px';
      target.style.opacity = '1';
      target.style.display = 'block';
      
      // Force reflow
      void target.offsetHeight;
      
      // Animate to 0
      target.style.height = '0';
      target.style.paddingTop = '0';
      target.style.paddingBottom = '0';
      target.style.marginTop = '0';
      target.style.marginBottom = '0';
      target.style.opacity = '0';
    });
    
    // Clean up after animation
    window.setTimeout(() => {
      target.style.display = 'none';
      resetAccordionStyles(target);
      target.style.opacity = '0';
    }, duration + 50);
  }
  
  // Direct close without animation
  function closeImmediately(target) {
    target.style.display = 'none';
    resetAccordionStyles(target);
    target.style.opacity = '0';
  }
  
  // Initialize accordions
  function initCustomFaqAccordions() {
    const faqToggles = document.querySelectorAll('[data-faq-toggle]');
    
    if (faqToggles.length === 0) {
      return;
    }
    
    // Use a WeakMap to track initialization without adding properties
    const initialized = new WeakMap();
    
    faqToggles.forEach(toggle => {
      // Skip if already initialized
      if (initialized.has(toggle)) return;
      initialized.set(toggle, true);
      
      const contentId = toggle.getAttribute('data-faq-toggle');
      const content = document.querySelector(`[data-faq-content="${contentId}"]`);
      const icon = toggle.querySelector('.custom-accordion__icon');
      
      // Set initial state - closed
      toggle.setAttribute('aria-expanded', 'false');
      if (content) {
        content.setAttribute('aria-hidden', 'true');
        content.style.display = 'none';
        resetAccordionStyles(content);
        content.style.opacity = '0';
      }
      
      if (icon) {
        icon.style.transform = 'rotate(0deg)';
        icon.style.transition = 'transform 0.3s ease';
      }
      
      // Replace trigger to remove existing listeners
      const newTrigger = toggle.cloneNode(true);
      toggle.parentNode.replaceChild(newTrigger, toggle);
      
      const currentTrigger = newTrigger;
      const currentContent = document.querySelector(`[data-faq-content="${contentId}"]`);
      const currentIcon = currentTrigger.querySelector('.custom-accordion__icon');
      
      // Add click listener with passive: false since we call preventDefault
      currentTrigger.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        
        const isExpanded = currentTrigger.getAttribute('aria-expanded') === 'true';
        
        if (isExpanded) {
          // Close this one
          currentTrigger.setAttribute('aria-expanded', 'false');
          if (currentContent) {
            currentContent.setAttribute('aria-hidden', 'true');
            customSlideUp(currentContent);
          }
          if (currentIcon) {
            currentIcon.style.transform = 'rotate(0deg)';
          }
        } else {
          // First, close all siblings
          const wrapper = currentTrigger.closest('.custom-faq-accordion');
          if (wrapper) {
            const siblings = wrapper.querySelectorAll('[data-faq-toggle]');
            siblings.forEach(sibling => {
              if (sibling !== currentTrigger) {
                const siblingId = sibling.getAttribute('data-faq-toggle');
                const siblingContent = document.querySelector(`[data-faq-content="${siblingId}"]`);
                if (siblingContent) {
                  const isSiblingOpen = sibling.getAttribute('aria-expanded') === 'true';
                  if (isSiblingOpen) {
                    sibling.setAttribute('aria-expanded', 'false');
                    siblingContent.setAttribute('aria-hidden', 'true');
                    customSlideUp(siblingContent);
                  } else {
                    closeImmediately(siblingContent);
                  }
                }
                const siblingIcon = sibling.querySelector('.custom-accordion__icon');
                if (siblingIcon) {
                  siblingIcon.style.transform = 'rotate(0deg)';
                }
              }
            });
          }
          
          // Open this one with a small delay
          setTimeout(() => {
            currentTrigger.setAttribute('aria-expanded', 'true');
            if (currentContent) {
              currentContent.setAttribute('aria-hidden', 'false');
              customSlideDown(currentContent);
            }
            if (currentIcon) {
              currentIcon.style.transform = 'rotate(180deg)';
            }
          }, 50);
        }
      }, { passive: false });
    });
  }
  
  // Check if we should initialize
  function checkAndInitCustomFaq() {
    if (!shouldInitialize()) return;
    setTimeout(initCustomFaqAccordions, 100);
  }
  
  // Initialize on DOM ready
  if (document.readyState === 'complete' || document.readyState === 'interactive') {
    checkAndInitCustomFaq();
  } else {
    document.addEventListener('DOMContentLoaded', checkAndInitCustomFaq);
  }
  
  // Re-initialize when new content is loaded (for AJAX/dynamic content)
  document.addEventListener('theme:section:load', function() {
    setTimeout(checkAndInitCustomFaq, 200);
  });
  
  // Debounced resize handler to avoid excessive reinitialization
  let resizeTimeout;
  window.addEventListener('resize', function() {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(checkAndInitCustomFaq, 250);
  });
})();
  // ^^ Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.
})();


